﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VXSManagerV2ABI = void 0;
class VXSManagerV2ABI {
    static GetABI() {
        return [
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "infController_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "vxsStrategies_",
                        "type": "address"
                    }
                ],
                "stateMutability": "nonpayable",
                "type": "constructor"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "strategy",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "burnToken",
                        "type": "address"
                    },
                    {
                        "indexed": false,
                        "internalType": "uint256",
                        "name": "amount",
                        "type": "uint256"
                    }
                ],
                "name": "BuyAndBurn",
                "type": "event"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "strategy",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "receiver",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "bnsToken",
                        "type": "address"
                    },
                    {
                        "indexed": false,
                        "internalType": "uint256",
                        "name": "amount",
                        "type": "uint256"
                    }
                ],
                "name": "BuyAndSend",
                "type": "event"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "strategy",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "receiver",
                        "type": "address"
                    },
                    {
                        "indexed": false,
                        "internalType": "uint256",
                        "name": "amount",
                        "type": "uint256"
                    }
                ],
                "name": "SendPLS",
                "type": "event"
            },
            {
                "inputs": [
                    {
                        "components": [
                            {
                                "internalType": "uint256",
                                "name": "rateUPLS",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "uPLSInStake",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "PLSToSwap",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "lastSplitTimestamp",
                                "type": "uint256"
                            },
                            {
                                "internalType": "address",
                                "name": "swapRouterV2",
                                "type": "address"
                            },
                            {
                                "internalType": "address[]",
                                "name": "swapPath",
                                "type": "address[]"
                            },
                            {
                                "internalType": "uint256",
                                "name": "swapMinPLSAmount",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "swapMaxPLSAmount",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "sendPLSIndex",
                                "type": "uint256"
                            },
                            {
                                "internalType": "address",
                                "name": "sendPLSReceiver",
                                "type": "address"
                            },
                            {
                                "internalType": "uint256",
                                "name": "bnsIndex",
                                "type": "uint256"
                            },
                            {
                                "internalType": "address",
                                "name": "sendAddress",
                                "type": "address"
                            },
                            {
                                "internalType": "bool",
                                "name": "isBurnWithERC20Burn",
                                "type": "bool"
                            }
                        ],
                        "internalType": "struct IVXS.Scope",
                        "name": "scope_",
                        "type": "tuple"
                    },
                    {
                        "internalType": "bool",
                        "name": "migration",
                        "type": "bool"
                    }
                ],
                "name": "configure",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "components": [
                            {
                                "internalType": "uint256",
                                "name": "swapMaxSlippageIndex",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "swapFrequencySeconds",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "splitFrequencySeconds",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "splitMinProfitAmount",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "maxGasAmount",
                                "type": "uint256"
                            }
                        ],
                        "internalType": "struct IVXS.BotConfig",
                        "name": "botConfig_",
                        "type": "tuple"
                    }
                ],
                "name": "configureBot",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "_strategyAdr",
                        "type": "address"
                    }
                ],
                "name": "getFeed",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "pls_",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "skip",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "take",
                        "type": "uint256"
                    }
                ],
                "name": "getStrategies",
                "outputs": [
                    {
                        "internalType": "address[]",
                        "name": "result_",
                        "type": "address[]"
                    },
                    {
                        "internalType": "uint256",
                        "name": "length_",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "_strategyAdr",
                        "type": "address"
                    }
                ],
                "name": "getStrategy",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "owner_",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "version_",
                        "type": "uint256"
                    },
                    {
                        "components": [
                            {
                                "internalType": "uint256",
                                "name": "rateUPLS",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "uPLSInStake",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "PLSToSwap",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "lastSplitTimestamp",
                                "type": "uint256"
                            },
                            {
                                "internalType": "address",
                                "name": "swapRouterV2",
                                "type": "address"
                            },
                            {
                                "internalType": "address[]",
                                "name": "swapPath",
                                "type": "address[]"
                            },
                            {
                                "internalType": "uint256",
                                "name": "swapMinPLSAmount",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "swapMaxPLSAmount",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "sendPLSIndex",
                                "type": "uint256"
                            },
                            {
                                "internalType": "address",
                                "name": "sendPLSReceiver",
                                "type": "address"
                            },
                            {
                                "internalType": "uint256",
                                "name": "bnsIndex",
                                "type": "uint256"
                            },
                            {
                                "internalType": "address",
                                "name": "sendAddress",
                                "type": "address"
                            },
                            {
                                "internalType": "bool",
                                "name": "isBurnWithERC20Burn",
                                "type": "bool"
                            }
                        ],
                        "internalType": "struct IVXS.Scope",
                        "name": "scope_",
                        "type": "tuple"
                    },
                    {
                        "internalType": "uint256",
                        "name": "upls_",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "pls_",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "withdrawalPLS_",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "_ownerAdr",
                        "type": "address"
                    }
                ],
                "name": "getStrategyAdr",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "strategyAdr_",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "infController",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "name": "isBot",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "name": "isRouterV2",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "strategyAdr_",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "rate_",
                        "type": "uint256"
                    }
                ],
                "name": "overrideRate",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "owner",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address[]",
                        "name": "bots_",
                        "type": "address[]"
                    },
                    {
                        "internalType": "bool",
                        "name": "value_",
                        "type": "bool"
                    }
                ],
                "name": "setBots",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address[]",
                        "name": "routers_",
                        "type": "address[]"
                    },
                    {
                        "internalType": "bool",
                        "name": "value_",
                        "type": "bool"
                    }
                ],
                "name": "setRoutersV2",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "uPLSToken",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "bool",
                        "name": "needUnstake_",
                        "type": "bool"
                    },
                    {
                        "internalType": "bool",
                        "name": "needWithdraw_",
                        "type": "bool"
                    },
                    {
                        "internalType": "bool",
                        "name": "needSwap_",
                        "type": "bool"
                    },
                    {
                        "internalType": "uint256",
                        "name": "minSwapRate_",
                        "type": "uint256"
                    }
                ],
                "name": "update",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "strategyAdr_",
                        "type": "address"
                    },
                    {
                        "internalType": "bool",
                        "name": "needUnstake_",
                        "type": "bool"
                    },
                    {
                        "internalType": "bool",
                        "name": "needWithdraw_",
                        "type": "bool"
                    },
                    {
                        "internalType": "uint256",
                        "name": "feedPLS_",
                        "type": "uint256"
                    },
                    {
                        "internalType": "bool",
                        "name": "needSwap_",
                        "type": "bool"
                    },
                    {
                        "internalType": "uint256",
                        "name": "minSwapRate_",
                        "type": "uint256"
                    }
                ],
                "name": "updateByBot",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "updateUPLSRate",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "strategy_",
                        "type": "address"
                    }
                ],
                "name": "updateUPLSRateByBot",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "vxsStrategies",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "wPLSToken",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "withdrawPLS",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "amount_",
                        "type": "uint256"
                    }
                ],
                "name": "withdrawUPLS",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            }
        ];
    }
}
exports.VXSManagerV2ABI = VXSManagerV2ABI;
//# sourceMappingURL=VXSManagerV2ABI.js.map